import { getPokemonUrl } from "../../utils/helpers";
import {
            ADD_POKEMON_TO_WISHLIST_REQUEST,
            ADD_POKEMON_TO_WISHLIST_SUCCESS,
            ADD_POKEMON_TO_WISHLIST_FAIL,
            ALREADY_ADDED_TO_WISHLIST_SUCCESS,
            ALREADY_ADDED_TO_WISHLIST_FAIL,

            REMOVE_FROM_WISHLIST_SUCCESS,
            REMOVE_FROM_WISHLIST_FAIL,

            ADD_POKEMON_TO_CART_SUCCESS, 
            ADD_POKEMON_TO_CART_REQUEST,
            ADD_POKEMON_TO_CART_FAIL ,
            REMOVE_POKEMON_FROM_CART_SUCCESS,
            REMOVE_POKEMON_FROM_CART_FAIL,

          CLEAR_ERRORS
} from "../constants/cartAndWishlistConstants";
import axios from 'axios';


//_______________add to wish list
 export const addPokemonToWishlist = (itemId) => async(dispatch, getState) => {

    try {

      // console.log(isInList)
             dispatch({type: ADD_POKEMON_TO_WISHLIST_REQUEST})

            const res = await axios(getPokemonUrl(itemId)).then(el=>el.data).then(el=>el)
      
            const {name, id, sprites, weight} = res
                      

            dispatch({
              type: ADD_POKEMON_TO_WISHLIST_SUCCESS,
              payload: {
                          name:name, 
                          id: id,
                          sprites: sprites,
                          price: weight+3,
                          // isInList
              },
              error: null ,          
            })

        localStorage.setItem('wishListItems', JSON.stringify(getState().addToWishlist.wishListItems));      

    } catch (error) {
        
        dispatch({
          type: ADD_POKEMON_TO_WISHLIST_FAIL,
          payload: error

         })
    }
}




//---------------REMOVE
export const removeWshlist = (id)=> async(dispatch, getState) => {

    try {

       dispatch({
         type: REMOVE_FROM_WISHLIST_SUCCESS,
         payload: id
       })

      localStorage.setItem('wishListItems', JSON.stringify(getState().addToWishlist.wishListItems))       

    } catch (error) {
       console.log(error)
       
       dispatch({
        type: REMOVE_FROM_WISHLIST_FAIL,
        payload: error  //---!!
      })
      
    }
}


//_____________________-add to cart
export const addPokemonToCart = (itemId) => async(dispatch, getState)=> {

         try {

            dispatch({type: ADD_POKEMON_TO_CART_REQUEST})

            const res = await axios(getPokemonUrl(itemId)).then(el=>el.data).then(el=>el)

      
            const {name, id, sprites, weight} = res
                      
            dispatch({
              type: ADD_POKEMON_TO_CART_SUCCESS,
              payload: {
                          name:name, 
                          id: id,
                          sprites: sprites,
                          price: weight+3,
                        //   itemAdded
              },
              error: null ,          
            })

              localStorage.setItem('cartItem', JSON.stringify(getState().addToCart.cartItem))       

    } catch (error) {
        
        dispatch({
          type: ADD_POKEMON_TO_CART_FAIL,
          payload: error
         })
    }
}


//___________remove from cart

export const removeFromCart = (id)=>(dispatch, getState) => {


           try {

                dispatch({
                  type: REMOVE_POKEMON_FROM_CART_SUCCESS,
                  payload: {}
                })

            localStorage.setItem('cartItem', JSON.stringify(getState().addToCart.cartItem))       
             
           } catch (error) {

            dispatch({
              type: REMOVE_POKEMON_FROM_CART_FAIL,
              payload: error
            })
           }

}

export const clearErrors = () =>(dispatch) => {
    
    dispatch({
        type: CLEAR_ERRORS
    })

}











